<template>
  <div>
    <div class="copyright">
      <div class="w1200" style="margin:0 auto;width: 1200px;">
        <div class="copyright_b">
          <ul>
            <li><router-link :to="{path:'/'}" title="首页">首页</router-link></li>
            <li><router-link :to="{path:'/Brand'}" title="品牌中心">品牌中心</router-link></li>
            <li><router-link :to="{path:'/Faster'}" title="快速下单">快速下单</router-link></li>
            <li><router-link :to="{path:'/IndustryList'}" title="行业资讯">行业资讯</router-link></li>
            <li><router-link :to="{path:'/About'}" title="公司介绍">公司介绍</router-link></li>
          </ul>
        </div>
        <div class="copyright_c clearfix">
          <div class="copyright_cl_l">
            <div class="padd">
              <h3>关于我们</h3>
              <p><router-link :to="{path:'/About'}" style="color:#333;">公司介绍</router-link></p>
              <p><router-link :to="{path:'/Contactus'}" style="color:#333;">联系我们</router-link></p>
              <p><router-link :to="{path:'/Supplier'}" style="color:#333;">加入我们</router-link></p>
            </div>
          </div>
          <div class="copyright_cl_l">
            <div class="padd">
              <h3>帮助中心</h3>
              <p><router-link :to="{path:'/Help'}" style="color:#333;">购物指南</router-link></p>
              <p><router-link :to="{path:'/Brand'}" style="color:#333;">品牌中心</router-link></p>
              <p><router-link :to="{path:'/Sitemap'}" style="color:#333;">网站地图</router-link></p>
            </div>
          </div>
          <div class="copyright_cl_l">
            <div class="padd">
              <h3>如何付款</h3>
              <p><router-link :to="{path:'/Bill'}" style="color:#333;">付款开票信息</router-link></p>
              <p><router-link :to="{path:'/Howpay'}" style="color:#333;">如何支付</router-link></p>
            </div>
          </div>
          <div class="copyright_cl_l">
            <div class="padd">
              <h3>服务政策</h3>
              <p><router-link :to="{path:'/Shiptime'}" style="color:#333;">配送政策</router-link></p>
              <p><router-link :to="{path:'/Returngoods'}" style="color:#333;">售后服务</router-link></p>
              <p><router-link :to="{path:'/Privacy'}" style="color:#333;">隐私申明</router-link></p>
            </div>
          </div>
          <div class="copyright_cl_l">
            <div class="padd">
              <h3>内容中心</h3>
              <p><router-link :to="{path:'/IndustryList'}" style="color:#333;">行业资讯</router-link></p>
              <p><router-link :to="{path:'/Resources'}" style="color:#333;">资源社区</router-link></p>
            </div>
          </div>
          <div class="copyright_cl">
            <div class="padd">
              <p><img src="../../assets/images/zp_14.png"> 400-040-7890</p>
              <p><img src="../../assets/images/zp_15.png"> www.nmzp.com</p>
              <p style="line-height:20px"><img src="../../assets/images/zp_16.png"> <a href="https://j.map.baidu.com/08/osZh" style="color:#333;" target="_blank">内蒙古自治区呼和浩特市赛罕区锡林南路与地质局南街交汇处未名楼A段1层1-0</a></p>
            </div>
          </div>
          <div class="copyright_cc">
            <img src="../../assets/images/zp_17.png" style="width:134px;">
          </div>
          <div class="copyright_cr">
            <div class="padd">
              <p>24小时全国服务热线</p>
              <span>400-040-7890</span>
              <router-link :to="{path:'/Service'}" title="在线客服">在线客服</router-link>
            </div>
          </div>
        </div>
        <div v-if="linksList.length > 0" class="links">
          <ul>
            <li><div style="position: relative;top: -1px;">友情链接：</div></li>
            <li v-for="(item,index) in linksList.slice(0, 10)" :key="index">
              <span v-if="index > 0">|</span>
              <a target="_blank" rel="nofollow" :title="item.title" :href="item.url">{{item.title}}</a>
            </li>
            <li v-if="linksList.length > 10">
              <span>|</span>
              <a target="_blank" style="cursor:pointer;" @click="showmore()">{{ more?'收起':'更多' }}</a>
            </li>
          </ul>
        </div>
        <div v-if="more" class="links links-more" style="display: block;">
          <ul>
            <li v-for="(item,indexs) in linksList.slice(10, 20)" :key="indexs">
              <span v-if="indexs > 0">|</span>
              <a target="_blank" rel="nofollow" :title="item.title" :href="item.url">{{item.title}}</a>
            </li>
          </ul>
        </div>
        <div v-if="more && linksList.length > 20" class="links links-more" style="display: block;">
          <ul>
            <li v-for="(item,indexss) in linksList.slice(20, 30)" :key="indexss">
              <span v-if="indexss > 0">|</span>
              <a target="_blank" rel="nofollow" :title="item.title" :href="item.url">{{item.title}}</a>
            </li>
          </ul>
        </div>
        <div v-if="more && linksList.length > 30" class="links links-more" style="display: block;">
          <ul>
            <li v-for="(item,indexsss) in linksList.slice(30, 40)" :key="indexsss">
              <span v-if="indexsss > 0">|</span>
              <a target="_blank" rel="nofollow" :title="item.title" :href="item.url">{{item.title}}</a>
            </li>
          </ul>
        </div>
        <div class="copyright_bottjin">
          版权所有：志鹏供应链（内蒙古）有限公司&emsp;<a href="https://beian.miit.gov.cn" rel="nofollow" target="_blank">蒙ICP备17002862号</a>&emsp;<a target="_blank" href="https://serv.nmzp.com/uploads/1/image/20220829/9b1c29c32b1875e3ddfda561f5033689.jpg">增值电信业务经营许可证</a>&emsp;<a class="rhc_gaba" target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010502001916">蒙公网安备15010502001916号</a>
        </div>
        <div class="copyright_bottjin" style="margin-top:-8px;">
          <a href="https://ss.knet.cn/verifyseal.dll?sn=e22090115010085405bou04074&ct=df&pa=xvcPoEZWwTatfBEf" rel="nofollow" target="_blank"><img src="../../assets/images/kxwz.png" alt="可信任网站" style="width:100px;"/></a>&emsp;
        </div>
      </div>
    </div>
    <!--右侧购物车开始-->
    <div class="cx_nav_right" style="display:none;">
      <div class="cx_nav_right_r">
        <ul>
          <template v-if="uid">
          <li class="cx_car">
            <div class="cx_car_tital"><em>购物车</em>
              <i class="cx_nav_right_r_close">
                <img src="../../assets/images/cx_close1.png" width="27" height="27"/>
              </i>
            </div>
            <div class="cx_checkbox">
                <input type="checkbox" cartcheckall="cartcheckall" value="" name="CheckAll"/><em>全选</em>
            </div>
            <div class="cx_mycar_list">
              <div class="cx_checkbox_next" v-for="(item,index) in cartList" :key="index">
                <input type="checkbox" name="Repeater" style="margin-left:10px;"/>
                <div class="cx_checkbox_next_r" style="margin-left:20px;">
                  <a href="" target="_blank" title="">
                    <img v-real-img="item.imgpath" src="../../assets/images/zwtp.jpg" alt="" width="54" height="54"/>
                  </a>
                  <div class="cx_checkbox_next_r_t">
                    <p>{{item.title}}</p>
                    <div>
                      <div class="pcc-item-name">
                        <div class="sl-jiajian">
                          <span class="sl-jia J_minus" cartminus="{$vo.cid}"></span>
                          <span class="sl-input">
                              <input type="text" class="amount-text J_input">
                          </span>
                          <span class="sl-jian J_add" cartadd="{$vo.cid}"></span>
                        </div>
                      </div>
                      <div class="cx_car_price">￥{{item.tax_price}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cx_car_js">
              <div>
                <div class="cx_car_js_l">已选 <em cartallnum="cartallnum">0</em> 件</div>
                <div class="cx_car_js_r" cartallprice="cartallprice"> ￥00.00 </div>
              </div>
              <a href="javascript:void (0);" cartsubmit="cartsubmit">结 算</a>
            </div>
          </li>
          <li class="cx_car">
            <div class="cx_car_tital">
              <em>购物车</em>
              <i class="cx_nav_right_r_close">
                <img src="../../assets/images/cx_close1.png" width="27" height="27"/>
              </i>
            </div>
            <div class="cx_zwsp" data-cartempty >
              <img src="../../assets/images/zpj_06.png" width="220" height="220"/>
              <p>购物车空空的，赶快去挑选心仪的商品吧~</p>
              <router-link :to="{path:'/'}">去首页看看</router-link>
            </div>
          </li>
          <li class="cx_myzj">
            <div class="cx_car_tital">
              <em>我的足迹</em>
              <i class="cx_nav_right_r_close">
                <img src="../../assets/images/cx_close1.png" width="27" height="27"/>
              </i>
            </div>
            <ul class="cx_myzj_list">
              <li v-for="(item,index) in historyGoods" :key="index">
                <router-link :to="{path:'/GoodsDetail', query:{id:item.goods_id}}" target="_blank" :title="item.title">
                  <img v-ral-img="item.imgpath" src="../../assets/images/zwtp.jpg" :alt="item.title" width="100" height="100"/>
                  <span style="overflow: hidden;text-overflow:ellipsis;white-space:normal;">{{item.title}}</span>
                  <span>￥{{item.tax_price}}</span>
                  <em>点击查看详情</em>
                </router-link>
              </li>
            </ul>
          </li>
          </template>
          <li class="cx_car" v-else>
            <div class="cx_car_tital">
              <em>购物车</em>
              <i class="cx_nav_right_r_close">
                <img src="../../assets/images/cx_close1.png" width="27" height="27"/>
              </i>
            </div>
            <div class="cx_zwsp" data-cartempty >
              <img src="../../assets/images/zpj_06.png" width="220" height="220"/>
              <p>您还没有登录，请先登录</p>
              <router-link :to="{path:'/Login'}">去登录</router-link>
            </div>
          </li>
        </ul>
      </div>
      <div class="cx_nav_right_l">
        <div class="cx_nav_right_l_r"></div>
        <div class="cx_channiu_box">
          <div class="cx_nav_right_l_r_01 cx_channiu">
            <router-link :to="{path:'/PersonalData'}">
              <div style="background:#000;width:36px;height:36px;padding:7px 0 0 5px;z-index:10001;position:relative;">
                <div style="width:23px;height:23px;overflow:hidden;border-radius:23px; behavior:url(js/PIE.htc);background:url(../../assets/public/images/touxiang02.jpg) no-repeat center / 100% auto;"></div>
              </div>
              <em>会员中心</em>
            </router-link>
          </div>
          <div class="cx_nav_right_l_r_02 cx_channiu">
            <a>
              <i></i>
              <em>购物车</em><span>99</span>
            </a>
          </div>
          <div class="cx_nav_right_l_r_03 cx_channiu">
            <a>
              <i></i>
              <em>我的3足迹</em>
            </a>
          </div>
          <div class="cx_nav_right_l_r_05 cx_channiu">
            <router-link :to="{path:'/Service'}" title="在线客服">
              <i></i>
              <em>在线客服</em>
            </router-link>
          </div>
        </div>
        <div class="cx_nav_right_l_r_06 cx_channiu">
          <router-link class="fhdb" :to="{path:'#'}">
            <i></i>
            <em>返回顶部</em>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/links'

export default {
  name: 'Bottom',
  data () {
    return {
      uid: '',
      cartList: [],
      linksList: [],
      more: false
    }
  },
  mounted () {
    this.getlinks()
  },
  methods: {
    getlinks () {
      api.getlinks().then(res => {
        this.linksList = res.items
      })
    },
    showmore () {
      if (this.more) {
        this.more = false
      } else {
        this.more = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Member/Bottom.vue